import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { useMemo } from 'react';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../../redux/store';
import { createAllCardRenderProperties } from './cardGroupUtils';
import { PlayerRevealedCardDisplay } from './playerRevealedCardDisplay';
export const PlayerRevealedCardsContainer = ({ seatIndex }) => {
    // numRevealedCards will be non-zero if the player is showing card backs only:
    const numRevealedCards = useAppSelector((state) => state.poker.revealedHands[seatIndex]?.length);
    const isShowingCardBacks = useAppSelector((state) => !state.poker.revealedHands[seatIndex]?.[0].card?.rankChar);
    const seatDimensions = useAppSelector((state) => state.gameDimensions.seatDimensions, shallowEqual);
    const groupContainerW = seatDimensions ? seatDimensions.w * 0.95 : undefined;
    const groupContainerH = seatDimensions ? seatDimensions.h * 0.7 : undefined;
    const allCardRenderProperties = useMemo(() => {
        if (!numRevealedCards || !groupContainerW || !groupContainerH) {
            return;
        }
        return createAllCardRenderProperties(groupContainerW, groupContainerH, numRevealedCards, {
            isShowingCardBack: isShowingCardBacks,
            isTopLeftAligned: true
        });
    }, [groupContainerH, groupContainerW, isShowingCardBacks, numRevealedCards]);
    if (!seatDimensions || !numRevealedCards || !allCardRenderProperties || !groupContainerW || !groupContainerH) {
        return null;
    }
    // coords is center of card group bounds
    const x = -(seatDimensions.w / 2) + groupContainerW / 2;
    const y = -(seatDimensions.h / 2) + groupContainerH / 2;
    return (_jsx(Container, { interactiveChildren: false, x: x, y: y, children: allCardRenderProperties.map((cardRenderProperties, i) => (_jsx(PlayerRevealedCardDisplay, { seatIndex: seatIndex, cardIndex: i, cardRenderProperties: cardRenderProperties }, i))) }));
};
